'use client';
import { useContext } from 'react';
import { useLayoutContext } from '@/context/LayoutContext';
import { useRouter } from 'next/navigation';
import { useRouterPath } from './routerPath';

export const useShowModal = () => {
  const { login } = useLayoutContext();
  const router = useRouter();
  const routerPath = useRouterPath();

  return (callBack) => {
    if (login) {
      callBack();
    } else {
      router.push(routerPath('/login'));
    }
  };
};
